import type { CastMember } from '@/types/tv';

interface CastListProps {
  cast: CastMember[];
}

const avatarTones = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-800',
  'bg-primary-200 text-primary-800',
];

export default function CastList({ cast }: CastListProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cast.map((member, index) => (
        <div
          key={`${member.name}-${member.role}`}
          className="flex items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200"
        >
          <span
            className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-full font-heading font-bold text-lg ${
              avatarTones[index % avatarTones.length]
            }`}
          >
            {member.name.slice(0, 1)}
          </span>
          <div className="min-w-0">
            <h3 className="font-medium text-sm text-foreground-950 line-clamp-1">{member.name}</h3>
            <p className="text-xs text-accent-600 mt-0.5 line-clamp-1">饰 {member.role}</p>
            <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed line-clamp-2">{member.bio}</p>
          </div>
        </div>
      ))}
    </div>
  );
}